import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import ActionsPill from 'components/application/ActionsPill';

import { resourceShape } from '../../helpers/serialisableResources';

export default function ReviewStatus({
  domainLatestVersion,
  onAcceptedClick,
  onRejectedClick,
  personnel,
  review,
  reviewedVersion,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'projectPersonnel.components.ReviewStatus',
  });

  const { t: i18nTCommon } = useTranslation('common');

  if (!review) {
    return (
      <ActionsPill
        color='grey'
        displayText={i18nTCommon('shared.notSent')}
        tooltipText={i18nT('tooltips.notSent')}
      />
    );
  }

  const {
    attributes: { state: reviewState },
    id: reviewId,
  } = review;

  const isAccepted = reviewState === 'accepted';
  const isRejected = reviewState === 'rejected';
  const isReviewed = isAccepted || isRejected;

  const reviewedVersionNumber = reviewedVersion?.attributes.displayNumber;

  const isLatestVersionReviewed =
    isReviewed &&
    domainLatestVersion.data.attributes.displayNumber === reviewedVersionNumber;

  const hasEmail = !!personnel.attributes.email;

  return (
    <ActionsPill
      color={
        isAccepted ?
          isLatestVersionReviewed ?
            'green'
          : 'amber'
        : isRejected ?
          'red'
        : hasEmail ?
          'cyan'
        : 'grey'
      }
      displayText={
        isReviewed ?
          i18nT(`signatureStatus.${reviewState}`, {
            versionNumber: reviewedVersionNumber,
          })
        : hasEmail ?
          i18nTCommon('shared.sent')
        : i18nT('signatureStatus.unableToSend')
      }
      onClick={
        isReviewed ?
          () =>
            isAccepted ? onAcceptedClick(reviewId) : onRejectedClick(reviewId)
        : undefined
      }
      tooltipText={
        isAccepted ?
          isLatestVersionReviewed ?
            i18nT('tooltips.acceptedLatestVersion')
          : i18nT('tooltips.acceptedPreviousVersion')
        : isRejected ?
          i18nT('tooltips.rejected')
        : hasEmail ?
          i18nT('tooltips.sentNotSigned')
        : i18nTCommon('personnel.noEmailAddressForPersonnel')
      }
    />
  );
}

ReviewStatus.propTypes = {
  domainLatestVersion: PropTypes.shape({
    data: resourceShape('version').isRequired,
  }).isRequired,
  onAcceptedClick: PropTypes.func.isRequired,
  onRejectedClick: PropTypes.func.isRequired,
  personnel: resourceShape('personnel').isRequired,
  review: resourceShape('review'),
  reviewedVersion: resourceShape('version'),
};
